// extracted by mini-css-extract-plugin
export default {"wrap":"index_wrap_cctpY","content":"index_content_HY5li"};